import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useFindPatientIhi = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (patientId) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/ihi/patients/${patientId}/find`
      );
      return response.data;
    },
  });
};
